module.exports = __webpack_public_path__ + "img/truckHead-red.688ecfed.svg";